/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Proxy_PoolInputs */

const en_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy pool`)
};

const ar_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعة البروكسي`)
};

const bn_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রক্সি পুল`)
};

const de_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy-Pool`)
};

const es_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de proxy`)
};

const fr_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pool de proxy`)
};

const pt_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto de proxy`)
};

const zh_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理池`)
};

const tr_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy havuzu`)
};

const ru_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пул прокси`)
};

const pl_svchip_proxy_pool = /** @type {(inputs: Svchip_Proxy_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pula proxy`)
};

/**
* | output |
* | --- |
* | "Proxy pool" |
*
* @param {Svchip_Proxy_PoolInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_proxy_pool = /** @type {((inputs?: Svchip_Proxy_PoolInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Proxy_PoolInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_proxy_pool(inputs)
	if (locale === "bn") return bn_svchip_proxy_pool(inputs)
	if (locale === "de") return de_svchip_proxy_pool(inputs)
	if (locale === "es") return es_svchip_proxy_pool(inputs)
	if (locale === "fr") return fr_svchip_proxy_pool(inputs)
	if (locale === "pt") return pt_svchip_proxy_pool(inputs)
	if (locale === "zh") return zh_svchip_proxy_pool(inputs)
	if (locale === "tr") return tr_svchip_proxy_pool(inputs)
	if (locale === "ru") return ru_svchip_proxy_pool(inputs)
	if (locale === "pl") return pl_svchip_proxy_pool(inputs)
	return en_svchip_proxy_pool(inputs)
});